// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : INTEREST WAIVER ADDED
// MODFIED DATA : 19-08-2025
import { API_URL } from '../../../../redux/const';
import { makeApiCall } from '../../../_common/api.utils';

/** ***************** FETCH AUTO LOAN INDEX START *********************** */
export const fetchAutoLoanIndexDetail = (listData: any) => {
	const data = {
		FetchAutoLoanIndexListToken: listData,
	};
	const url = `${API_URL}fetchAutoLoanIndexList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH AUTO LOAN INDEX END *********************** */

/** ***************** FETCH AUTO LOAN COLLECTION START *********************** */
export const fetchAutoLoanCollectionDetail = (listData: any) => {
	const data = {
		GetAutoLoanCollectionToken: listData,
	};
	const url = `${API_URL}fetchAutoLoanCollection`;
	return makeApiCall(url, data);
};
/** ***************** FETCH AUTO LOAN COLLECTION END *********************** */

/** ***************** UPDATE AUTO LOAN COLLECTION START *********************** */
export const autoLoanCollectionUpdate = (fetchData: JSON) => {
	const data = {
		UpdateAutoLoanPaidCollectionToken: fetchData,
	};
	const url = `${API_URL}updateAutoLoanPaid`;
	return makeApiCall(url, data);
};
/** ***************** UPDATAE AUTO LOAN COLLECTION END *********************** */

/** ***************** REVERT AUTO LOAN COLLECTION END *********************** */
export const autoLoanCollectionRevert = (fetchData: JSON) => {
	const data = {
		RevertAutoLoanPaidEntryToken: fetchData,
	};
	const url = `${API_URL}revertAutoLoanPaidEntry`;
	return makeApiCall(url, data);
};
/** ***************** REVERT AUTO LOAN COLLECTION END *********************** */

/** ***************** REVERT AUTO LOAN MEMBER WALLET START *********************** */
export const revertAutoLoanMemberSaving = (deleteData: JSON) => {
	const data = {
		RevertAutoLoanMemberWalletData: deleteData,
	};
	const url = `${API_URL}revertAutoLoanMemberWallet`;
	return makeApiCall(url, data);
};
/** *****************REVERT AUTO LOAN MEMBER WALLET END *********************** */

/** ***************** AUTO LOAN INTEREST WAIVER UPDATE START *********************** */
export const autoLoanInterestWaiverUpdateAPI = (listData: any) => {
	const data = {
		UpdateAutoLoanInterestWaiverData: listData,
	};
	const url = `${API_URL}updateAutoLoanInterestWaiver`;
	return makeApiCall(url, data);
};
/** ***************** AUTO LOAN INTEREST WAIVER UPDATE END *********************** */

/************************ AUTO LOAN COLLECTION APPROVAL START ****************** */
export const autoLoanCollectionApprovalAPI = (Data: any) => {
	const data = {
		ApproveAutoLoanCollectionToken: Data,
	};
	const url = `${API_URL}aproveAutoLoanCollection`;
	return makeApiCall(url, data);
};
/************************ AUTO LOAN COLLECTION APPROVAL END ****************** */

/************************ AUTO LOAN COLLECTION VEHICLE SEIZED START ****************** */
export const autoLoanCollectionVehicleSeizedAPI = (Data: any) => {
	const data = {
		AutoLoanCollectionVehicleSeizedToken: Data,
	};
	const url = `${API_URL}updateVehicleSeized`;
	return makeApiCall(url, data);
};
/************************ AUTO LOAN COLLECTION VEHICLE SEIZED END ****************** */

/************************ FETCH AUTO LOAN VEHICLE DETAILS START ****************** */
export const fetchAutoLoanVehicleDetailsAPI = (listData: any) => {
	const data = {
		FetchAutoLoanMemberVehicleDetailsToken: listData,
	};
	const url = `${API_URL}fetchAutoLoanMemberVehicleDetails`;
	return makeApiCall(url, data);
};
/************************ FETCH AUTO LOAN VEHICLE DETAILS END ****************** */

/************************ ADD AUTO LOAN MEMBER WALLET START ****************** */
export const addAutoLoanMemberWalletService = (fetchData: any) => {
	const data = {
		AddAutoLoanMemberWalletToken: fetchData,
	};
	const url = `${API_URL}addAutoLoanMemberWallet`;
	return makeApiCall(url, data);
};
/************************ ADD AUTO LOAN MEMBER WALLET END ****************** */

/************************ FETCH AUTO LOAN REPAYMENT START ****************** */
export const fetchAutoLoanRepaymentDetail = (listData: any) => {
	const data = {
		FetchAutoLoanRepaymentData: listData,
	};
	const url = `${API_URL}fetchAutoLoanMemberRepayment`;
	return makeApiCall(url, data);
};
/************************ FETCH AUTO LOAN REPAYMENT END ****************** */

/************************ FETCH AUTO LOAN ARREAR COLLECTIONS START ****************** */
export const fetchAutoLoanArrearCollectionsDetail = (listData: any) => {
	const data = {
		FetchAutoLoanArrearCollectionsToken: listData,
	};
	const url = `${API_URL}fetchAutoLoanMemberArrearCollections`;
	return makeApiCall(url, data);
};
/************************ FETCH AUTO LOAN ARREAR COLLECTIONS END ****************** */
